import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-homepage-one',
    templateUrl: './homepage-one.component.html',
    styleUrls: ['./homepage-one.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HomepageOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
